import { render, staticRenderFns } from "./LayoutBasic.vue?vue&type=template&id=45525326&scoped=true&"
import script from "./LayoutBasic.vue?vue&type=script&lang=js&"
export * from "./LayoutBasic.vue?vue&type=script&lang=js&"
import style0 from "./LayoutBasic.vue?vue&type=style&index=0&id=45525326&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45525326",
  null
  
)

export default component.exports